export default __webpack_public_path__ + "images/d0e3eee985415a8a768d421d1a07a9e5-medicine.webp";